import { GetStaticProps } from 'next';
import { useRouter } from 'next/router';
import qs from 'qs';
import React, { useEffect } from 'react';
import LogoLoadingWithLogo from '../components/logo-loading-with-logo/logo-loading-with-logo';
import { LOADING_DATA_PAGE } from '../services/utils/CONST';
import { getLocale } from '../services/utils/get-translates';
import { routeWithParamAs } from '../services/utils/route';

const Index = () => {
    const router = useRouter();

    useEffect(() => {
        if ('redirection_key' in router.query)
            routeWithParamAs(router, `${LOADING_DATA_PAGE}?${qs.stringify(router.query)}`);
    }, [router]);

    return <LogoLoadingWithLogo />;
};

export default Index;

export const getStaticProps: GetStaticProps = (context) => ({
    props: {
        messages: {
            ...require(`../messages/common/${getLocale(context)}.json`),
        },
    },
});
